// src/components/CostPoolBarChart.tsx
import React from 'react';
import AnalysisWebsiteVisits from 'src/sections/overview/analytics/analysisbargraph';

const CostPoolBarChart: React.FC = () => {
  return (
    <div>
      <AnalysisWebsiteVisits
        title="Cost Pool Spend"
        subheader="This Month (March 2024) (in USD)"
        chart={{
          labels: [
            'License',
            'A/M',
            'Infra',
            'Staff',
            'Hosting',
            'Server ',
            'Help Desk',
            'Other',
          ],
          series: [
            {
              name: 'Cost',
              type: 'column',
              fill: 'solid',
              data: [412719, 50000, 72000, 385545, 92220, 440000, 57799,0],
            },
          ],
        }}
      />
    </div>
  );
};

export default CostPoolBarChart;
